import { render, staticRenderFns } from "./CustomTodo.vue?vue&type=template&id=60bd968a&scoped=true"
import script from "./CustomTodo.vue?vue&type=script&lang=js"
export * from "./CustomTodo.vue?vue&type=script&lang=js"
import style0 from "./CustomTodo.vue?vue&type=style&index=0&id=60bd968a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd968a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60bd968a')) {
      api.createRecord('60bd968a', component.options)
    } else {
      api.reload('60bd968a', component.options)
    }
    module.hot.accept("./CustomTodo.vue?vue&type=template&id=60bd968a&scoped=true", function () {
      api.rerender('60bd968a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CustomTodo.vue"
export default component.exports